import SettingScreen from "../screens/common/SettingScreen";
import language from "../language";
import icons from "./icons";
import AccountScreen from "../screens/Merchant/AccountScreen";
import AnalyticsScreen from "../screens/Merchant/AnalyticsScreen";
import AggregatorScreen from "../screens/Merchant/AggregatorScreen";
import CollectionsScreen from "../screens/Merchant/CollectionsScreen";
import TransactionsScreen from "../screens/Merchant/reports/transactions/TransactionsScreen";
import SummaryScreen from "../screens/Merchant/reports/transactions/SummaryScreen";
import RefundSummaryScreen from "../screens/Merchant/reports/refund/RefundSummaryScreen";
import ShiftsReportScreen from "../screens/Merchant/reports/shifts/ShiftsTransactionsScreen";

import RefundTransactionsScreen from "../screens/Merchant/reports/refund/RefundTransactionsScreen";
import InvoiceScreen from "../screens/Merchant/InvoiceScreen";
import ReconciliationScreen from "../screens/Merchant/ReconciliationScreen";
import BalanceScreen from "../screens/Merchant/fundTransfer/BalanceScreen";
import RequestScreen from "../screens/Merchant/fundTransfer/RequestScreen";

export default (lng = "english", verified) => {
  try {
    let sidebarList = [
      {
        parentPath: "/merchant",
        path: "/analytics",
        name: language[lng].home,
        icon: icons.home,
        component: <AnalyticsScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business", "individual"],
      },
      {
        parentPath: "/merchant",
        path: "/payments",
        name: language[lng].payments,
        icon: icons.transaction,
        component: <SummaryScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business", "individual"],
        menus: [
          {
            path: "/",
            name: language[lng].summary,
            component: <SummaryScreen />,
          },
          {
            path: "/transactions",
            name: language[lng].transactions,
            component: <TransactionsScreen />,
          },
        ],
      },
      {
        parentPath: "/merchant",
        path: "/refund",
        name: language[lng].refund,
        icon: icons.refund,
        component: <RefundSummaryScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business", "individual"],
        menus: [
          {
            path: "/summary",
            name: language[lng].summary,
            component: <RefundSummaryScreen />,
          },
          {
            path: "/transactions",
            name: language[lng].transactions,
            component: <RefundTransactionsScreen />,
          },
        ],
      },
      {
        parentPath: "/merchant",
        path: "/shift-report",
        name: language[lng].shifts,
        icon: icons.refund,
        component: <ShiftsReportScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business", "individual"],
        menus: [
          {
            path: "/shifts",
            name: language[lng].shifts,
            component: <ShiftsReportScreen />,
          },
          // {
          //   path: "/transactions",
          //   name: language[lng].transactions,
          //   component: <RefundTransactionsScreen />,
          // },
        ],
      },
      {
        parentPath: "/merchant",
        path: "/reconciliation",
        name: language[lng].reconciliation,
        icon: icons.reconciliation,
        component: <ReconciliationScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
        menus: [
          {
            path: "/summary",
            name: language[lng].processing_report,
            component: <ReconciliationScreen />,
          },
          // {
          //   path: "/transactions",
          //   name: language[lng].settlements,
          //   component: <RefundTransactionsScreen />,
          // },
        ],
      },
      {
        parentPath: "/merchant",
        path: "/accounts",
        name: language[lng].accounts,
        icon: icons.bankAccount,
        component: <AccountScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
      },
      {
        parentPath: "/merchant",
        path: "/aggregators",
        name: language[lng].aggregators,
        icon: icons.store,
        component: <AggregatorScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
      },
      {
        parentPath: "/merchant",
        path: "/collections",
        name: language[lng].collections,
        icon: icons.business,
        component: <CollectionsScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
      },
      {
        parentPath: "/merchant",
        path: "/balance",
        name: language[lng].fund_transfer_balance,
        icon: icons.bankAccount,
        component: <BalanceScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
        menus: [
          {
            path: "/balance",
            name: language[lng].balances,
            component: <BalanceScreen />,
          },
          {
            path: "/requests",
            name: language[lng].requests,
            component: <RequestScreen />,
          },
          // {
          //   path: "/transactions",
          //   name: language[lng].settlements,
          //   component: <RefundTransactionsScreen />,
          // },
        ],
      },
      {
        parentPath: "/merchant",
        path: "/invoices",
        name: language[lng].invoices,
        icon: icons.invoice,
        component: <InvoiceScreen />,
        accessRoles: ["ROLE_MERCHANT"],
        accountCategory: ["business"],
      },

      {
        parentPath: "/dashboard",
        path: "/settings",
        name: language[lng].settings,
        icon: icons.setting,
        component: <SettingScreen />,
        accessRoles: ["ROLE_MERCHANT", "ROLE_ADMIN"],
        accountCategory: ["individual"],
      },
    ].filter((el) => {
      return el;
    });

    return sidebarList;
  } catch (error) {
    window.location.href = "/";
    return [];
  }
};
